import {
    PickableTeamParticipantUserResource,
    TeamResource,
} from 'dy-frontend-http-repository/lib/modules/Team/resources';
import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import domain from './domain';
import { resetTeam, resetTeamOccupancy, resetTeamPickableParticipantUsers } from './events';
import { TeamOccupancyWithParticipantsResource } from '../types';

// Team pickable user
export const $teamPickableParticipantUsers = domain
    .createStore<CollectionResource<PickableTeamParticipantUserResource, {}> | null>(null)
    .reset(resetTeamPickableParticipantUsers);

// Team resource
export const $team = domain.createStore<TeamResource | null>(null).reset(resetTeam);

// Team occupancy, including each participant's own current-week score
export const $teamOccupancy = domain
    .createStore<CollectionResource<TeamOccupancyWithParticipantsResource, {}> | null>(null)
    .reset(resetTeamOccupancy);
